import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router';
import { Box } from '@mui/material';
import LayoutWrapperStyles from '../styles/Layout';
import Navbar from '../components/common/Navbar';
import { NAV_DRAWER_WIDTH } from '../configs/Constants';
import RoutePaths from '../configs/Routes';

const useStyles = makeStyles(LayoutWrapperStyles);

const PrivateWrapper = ({ pageName, children }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    document.title = pageName;
  }, [navigate, pageName]);

  useEffect(async () => {
    if (!localStorage.getItem('isLoggedIn')) {
      navigate(RoutePaths.LOGOUT);
    }
  }, [pageName]);

  return (
    <Box className={classes.wrapper}>
      <Navbar title={pageName} open={open} setOpen={setOpen} />
      <Box
        sx={{
          width: '100%',
          ...(open && {
            marginLeft: `${NAV_DRAWER_WIDTH}px !important`,
            width: `calc(100% - ${NAV_DRAWER_WIDTH}px) !important`,
          }),
        }}
        className={classes.content}
      >
        {children}
      </Box>
    </Box>
  );
};

PrivateWrapper.propTypes = {
  pageName: PropTypes.string,
  children: PropTypes.element.isRequired,
};
PrivateWrapper.defaultProps = {
  pageName: '',
};

export default PrivateWrapper;
